import type { FaireProductEntity } from "../../entity_types/product";

export const p_u8up23msf3: FaireProductEntity = {
  token: "p_u8up23msf3",
  type: "product",
  name: "LM-TS-1009 Bandana Adult Yam Comfort Colors Tee",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/2e1975c39faba348414c537d49a2db02157aa306d751e7e0ec3e6121dee1ff08.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.5,
  description: "This Girlie Girl Originals tee features a screen-printed bandana motif on a comfortable adult fit Comfort Colors tee in yam. Designed for casual womenswear, it combines bold graphic appeal with Southern-inspired style, making it an excellent choice for boutiques seeking trend-driven apparel.",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:38.300Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
